$(function() {

  var countryCode = null;
  var $cookiesNotice = $('.cookies-notice');
  var $dismissButton = $('.cookies-notice .js-dismiss-btn');
  var HIDE_ME = 'hideMe';
  var COOKIE_NOTICE = 'cookieNotice';
  var JS_IS_ACTIVE = 'js-is-active';

  /**
   * Get a locally stored value
   */
  function getStoredValue(id) {
    if (window.localStorageFallback) {
      return window.localStorageFallback.getItem(id)
    }
  }

  /**
   * Set a locally stored value
   */
  function setStoredValue(id, value) {
    if (window.localStorageFallback) {
      return window.localStorageFallback.setItem(id, value)
    }
  }

  /**
   * Remove a locally stored value
   */
  function removeStoredValue(id) {
    if (window.localStorageFallback) {
      return window.localStorageFallback.removeItem(id)
    }
  }

  function checkEasyLocation() {
    // we are relying on EasyLocation for geo-ip lookups. It saves this data in local storage
    var locationDataRaw = getStoredValue('geoip-location')
    if (locationDataRaw) {
      var locationData = JSON.parse(locationDataRaw)

      countryCode = locationData.value.continent.code;
      
      // FYI this just checks the visitor's continent, not if they're from the European Union
      if (countryCode === 'EU') {
        $cookiesNotice.addClass(JS_IS_ACTIVE);
      }
    } else {
      setTimeout(checkEasyLocation, 300)
    }
  }

  function hasDismissedCookieNotice() {
    return (getStoredValue(COOKIE_NOTICE) === HIDE_ME)
  }

  $dismissButton.on('click', function() {
    $cookiesNotice.removeClass(JS_IS_ACTIVE);

    setStoredValue(COOKIE_NOTICE, HIDE_ME)
  })

  // check for any previous actions
  if (!hasDismissedCookieNotice()) {
    // check for the easylocation service
    setTimeout(checkEasyLocation, 300)
  }
});
